import { z } from 'zod';

export const SubTenantAccessModeSchema = z.enum(['ALL', 'INCLUDE', 'EXCLUDE']);
export type SubTenantAccessMode = z.infer<typeof SubTenantAccessModeSchema>;

const MAX_SUB_TENANT_IDS = 200;

export const UserSubTenantAccessSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  userId: z.string(),
  mode: SubTenantAccessModeSchema,
  subTenantIds: z.array(z.string()),
  updatedAt: z.iso.datetime(),
});

export type UserSubTenantAccess = z.infer<typeof UserSubTenantAccessSchema>;

export const UserSubTenantAccessResponseSchema =
  UserSubTenantAccessSchema.extend({
    userName: z.string().optional(),
    userEmail: z.string().optional(),
  });

export type UserSubTenantAccessResponse = z.infer<
  typeof UserSubTenantAccessResponseSchema
>;

export const SetUserSubTenantAccessSchema = z.object({
  userId: z.string().min(1, 'User ID is required'),
  mode: SubTenantAccessModeSchema,
  subTenantIds: z.array(z.string()).max(MAX_SUB_TENANT_IDS).default([]),
});

export type SetUserSubTenantAccessInput = z.infer<
  typeof SetUserSubTenantAccessSchema
>;

export const UpdateUserSubTenantAccessSchema = z.object({
  mode: SubTenantAccessModeSchema,
  subTenantIds: z.array(z.string()).max(MAX_SUB_TENANT_IDS),
});

export type UpdateUserSubTenantAccessInput = z.infer<
  typeof UpdateUserSubTenantAccessSchema
>;

export const UserSubTenantAccessListResponseSchema = z.object({
  items: z.array(UserSubTenantAccessResponseSchema),
  total: z.number(),
});

export type UserSubTenantAccessListResponse = z.infer<
  typeof UserSubTenantAccessListResponseSchema
>;

export const SubTenantAccessConfigSchema = z.object({
  mode: SubTenantAccessModeSchema,
  subTenantIds: z.array(z.string()),
});

export type SubTenantAccessConfig = z.infer<typeof SubTenantAccessConfigSchema>;

export const SubTenantSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type SubTenantSummary = z.infer<typeof SubTenantSummarySchema>;

export const SubTenantSummaryListResponseSchema = z.object({
  items: z.array(SubTenantSummarySchema),
});

export type SubTenantSummaryListResponse = z.infer<
  typeof SubTenantSummaryListResponseSchema
>;
